import IPLYearsCarousel from "@/component/IPL/IPLYearsCarousel";
import PurpleCapTable from "@/component/IPL/PurpleCapTable";
import TopPlayerCard from "@/component/IPL/TopPlayerCard";
import { getDataFromSSR } from "@/handlers/client/commonClient";
import dynamic from "next/dynamic";

import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";

import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import IPLSponsor from "@/component/IPL/IPLSponser";
import FieldingTable from "@/component/IPL/FieldingTable";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const MGIDAAdsScript = dynamic(() => import("@/component/Ads/MGIDAdsScript"));
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const ItemsList = dynamic(() => import("@/component/SeoTags/ItemsList"));
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);
// const WebsiteSchema = dynamic(() =>
//   import("@/component/SeoTags/WebsiteSchema")
// );
// const IPLFAQSchema = dynamic(() => import("@/component/SeoTags/IPLFAQSchema"));
const IPLMenu = dynamic(() => import("@/component/IPL/IPLMenu"));
const IPLCommonFooter = dynamic(() =>
  import("@/component/IPL/IPLCommonFooter")
);

const FieldingPage = ({
  categoryNewsListData = null,
  isMobileDevice = false,
  faqData = null,
  year = 2025,

  statsData = null,
}) => {
  const iplYearsFilter = {
    2025: "8307",
    2024: "5970",
    2023: "5157",
    2022: "4623",
    2021: "4165",
    2020: "3978",
    2019: "3130",
    2018: "2940",
  };
  const fieldingFilters = ["Most Dismissals", "Most Catches", "Most Run Outs"];

  const [selectedYear, setSelectedYear] = useState(year);
  const [tourId, setTourId] = useState(iplYearsFilter[selectedYear || year]);
  const handleSelectYear = (year) => {
    setSelectedYear(year);
  };
  const [selectedBowlingFilter, setBowlingFilter] = useState(
    fieldingFilters[0]
  );
  const handleBowlingDropdownChange = (e) => {
    setBowlingFilter(e.target.value);
  };

  const [statData, setStatData] = useState([]);
  const [searchByName, setSearchByName] = useState("");
  // console.log('the statsData is' , statsData)
  useEffect(() => {
    const getStatsData = async () => {
      const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
      let data = await getDataFromSSR(
        `${websiteUrl}/api/getStatsAPI?tourID=${tourId}&statsId=21`
      );

      const newLeaderboard = data?.data?.data?.leaderboard || [];
      setStatData(newLeaderboard);
    };

    getStatsData();
  }, [year, tourId]);

  useEffect(() => {
    if (!statsData) return;

    const fullLeaderboard = statsData?.leaderboard || [];

    setStatData(
      searchByName
        ? fullLeaderboard.filter((value) =>
            value.player_name.toLowerCase().includes(searchByName.toLowerCase())
          )
        : fullLeaderboard
    );
  }, [searchByName, statsData]);
  // ads implement
  const router = useRouter();
  const currentPath = router?.asPath?.split("?")[0];
  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [currentPath.split("/")[1], currentPath.split("/")[2]]
        : currentPath.split("/")[1],
    Keywords: categoryNewsListData?.seo_detail?.meta_keyword.split(","),
  };
  const [scrolled, setScrolled] = useState(true);
  // useEffect(() => {
  //   async function onFirstScroll() {
  //     if (!scrolled) {
  //       setScrolled(true);
  //     }
  //   }

  //   function handleScroll() {
  //     onFirstScroll();

  //     window.removeEventListener("scroll", handleScroll);
  //   }

  //   window.addEventListener("scroll", handleScroll);
  // }, []);
  // ads

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF_1_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                [300, 250],
                "div-gpt-ad-1659434785315-0"
              )
              .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          }
          scrolled &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
          scrolled&& googletag?.cmd.push(function () {
            var INTERSTITIALAd = googletag
              ?.defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_HP_Mweb_Interstitial",
                googletag?.enums.OutOfPageFormat.INTERSTITIAL
              )
              ?.addService(googletag.pubads());
            INTERSTITIALAd && googletag?.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_2_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-3"
              )
              ?.addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }
          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
        });
      }
      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
                : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);
  }, [scrolled]);
  const masterConfig = useContext(MasterConfigContext);
  const iplKeys = masterConfig["ipl_2025"];

  const title =
    year == 2025
      ? "IPL 2025 Fielding Records: Most Catches, Run-Outs, Top Fielders & Stats"
      : `${statData[0]?.player_name}: Most Catches in IPL ${year} | Fielding Records & Stats`;
  const description =
    year == 2025
      ? `IPL 2025's top fielders with most catches, best run-outs, and game-changing moments. Check who leads the fielding stats and catch the complete leaderboard.`
      : `Most Catches in IPL ${year}: Check out IPL ${year} fielding records. ${statData[0]?.player_name} leads with the most catches this season. See top 10 players, match-by-match stats, and fielding highlights.`;
  const keywords =
    year == 2025
      ? `IPL 2025 Fielding Records, Most Catches in IPL 2025, IPL Best Fielder  2025, Run Out Record in IPL 2025, Top Fielders in IPL 2025, आईपीएल  2025 में सबसे ज्यादा कैच, IPL 2025 Top Fielding Performances, Best Catches in IPL 2025, IPL 2025 Catching Stats`
      : `Most Catches in IPL ${year}, ${statData[0]?.player_name} Fielding Stats IPL ${year}, IPL ${year} Top Fielders, IPL ${year} Catch Records, Best Fielders IPL ${year}, Most Catches by a Player in IPL ${year}

`;
  const canonical =
    year == 2025
      ? "/sports/ipl/fielding-records"
      : `/sports/ipl/fielding-records-${year}`;

  const breadCrumbs = [
    {
      id: "1",
      title: "Sports",
      canonical_url: "/sports",
      amp_url: "",
    },
    {
      id: "2",
      title: "IPL",
      canonical_url: "/sports/ipl",
      amp_url: "",
    },
    {
      id: "3",
      title: "Purple Cap",
      canonical_url: "/sports/ipl/fielding-records",
      amp_url: "",
    },
  ];

  return (
    <div>
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
        noAuthorTag={false}
        image={categoryNewsListData?.seo_detail?.og_image}
        lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript isElection={true} />
      {/* <WebsiteSchema /> */}
      {/* <IPLFAQSchema /> */}
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />

      <ItemsList
        data={categoryNewsListData?.content}
      />
      <Breadcrumb breadcrumbList={breadCrumbs} />
      <MGIDAAdsScript delay={true} />
      <div className="mx-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />

        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="728px"
          minHeight="90px"
        />
      </div>

      {iplKeys?.showSponsor && (
        <IPLSponsor color="white" masterConfigKey={iplKeys} />
      )}
      <IPLMenu />
      <section className="mx-4 border-1 shadow-md">
        <h1 className="text-lg font-semibold my-4">
          {year == 2025
            ? "IPL 2025 Fielding Records"
            : `IPL ${year} Fielding Records`}
        </h1>
        <TopPlayerCard playerData={statData} playerType="fielding" />
        <IPLYearsCarousel
          matchData={iplYearsFilter}
          handleSelectYear={handleSelectYear}
          selectedYear={year || selectedYear}
          setTourId={setTourId}
        />
        {scrolled && (
          <div className="my-3">
            <AdSlot300x250
              divId={"div-gpt-ad-1659434604998-0"}
              minWidth="300px"
              minHeight="250px"
            />

            <AdSlot728x90
              divId={"div-gpt-ad-1707804176041-2"}
              minWidth="720px"
              minHeight="90px"
            />
          </div>
        )}

        <h2 className=" mx-3  my-4 font-semibold text-lg">
          IPL {selectedYear} In Numbers
        </h2>
        <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-4 mx-3 my-2">
          {/* Dropdown Filter */}
          <select
            id="battingFilter"
            value={selectedBowlingFilter}
            onChange={handleBowlingDropdownChange}
            className="border rounded p-2 w-full"
          >
            {fieldingFilters?.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>

          {/* Search Input with Icon Inside */}
          <div className="relative w-full">
            <input
              id="search"
              className="placeholder:italic placeholder:text-slate-400 block w-full bg-white border border-slate-300 rounded-md py-2 pl-3 pr-10 shadow-sm focus:outline-none"
              placeholder="Search by Player Name"
              type="text"
              name="search"
              value={searchByName}
              onChange={(e) => setSearchByName(e.target.value)}
            />

            {/* Search Icon Inside Input */}
            <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
              <img
                src="/assets/icons/svg/search.svg"
                alt="Search Icon"
                className="w-5 h-5 text-gray-500"
              />
            </div>
          </div>
        </div>

        <FieldingTable
          tableContent={statData}
          selectedFilter={selectedBowlingFilter}
          selectedYear={year || selectedYear}
        />
        {scrolled && (
          <div className="my-3">
            <AdSlot300x250
              divId={"div-gpt-ad-1659434785315-0"}
              minWidth="300px"
              minHeight="250px"
            />

            <AdSlot728x90
              divId={"div-gpt-ad-1707804176041-3"}
              minWidth="720px"
              minHeight="90px"
            />
          </div>
        )}
      </section>
     
      <div className="mx-4">
      <IPLCommonFooter
        categoryNewsListData={categoryNewsListData}
        faqData={faqData}
        isMobileDevice={isMobileDevice}
        showAds={false}
        scrolled={scrolled}
      />
      {scrolled && (
        <AdSlot300x250
          divId={"div-gpt-ad-1659435474737-0"}
          minWidth="300px"
          minHeight="250px"
        />
      )}

      {scrolled && (
        <AdSlot728x90
          divId="div-gpt-ad-1659425743360-0"
          minWidth="720px"
          minHeight="90px"
        />
      )}</div>
      <div data-type="_mgwidget" data-widget-id="1584885"></div>
      <script
        async
        dangerouslySetInnerHTML={{
          __html: `window.addEventListener("load", function() {
            (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
          });`,
        }}
      ></script>
    </div>
  );
};

export default FieldingPage;
